import { configurationsPiletModals } from '@sharefiledev/configurations-pilet-sdk';
import { OverlayModalOptions } from '@sharefiledev/sharefile-appshell';

export function getDefaultModalOptions(): Partial<
	OverlayModalOptions<typeof configurationsPiletModals.editSettingsTabs>
> {
	return {
		modalProps: {
			centered: true,
			width: '60%',
			styles: {
				body: {
					maxHeight: '100vh',
					overflowY: 'auto',
					overflowX: 'hidden',
				},
			},
			footer: null,
		},
	};
}
